import request from "@/utils/request";

// 下载-文件id
export function getDownloadFile(id) {
  return request({
    url: "/mes/commonAttachment/download/" + id,
    method: "get",
    responseType: "arraybuffer"
  });
}

// 订单跟进数量统计
export function purchaseOrderTrackingCount(data) {
  return request({
    url: "/mes/mesPurchaseOrder/purchaseOrderTrackingCount?type=mes",
    method: "post",
    data: data
  });
}

// 订单跟踪明细
export function purchaseOrderTrackingDetails(id) {
  return request({
    url: "/mes/mesPurchaseOrder/purchaseOrderTrackingDetails/" + id + "/mes",
    method: "post"
  });
}

// 采购待接单统计
export function getPurchaseOrderCount(data) {
  return request({
    url: "/pom/pomPurchaseApplyOrder/purchaseOrderCount?type=mes",
    method: "post",
    data: data
  });
}

// 采购接单列表页
export function purchaseOrderPageList(data) {
  return request({
    url: "/pom/pomPurchaseApplyOrder/purchaseOrderPageList?type=mes",
    method: "post",
    data: data
  });
}

// 获取报价单尺码数量
export function getApplyOrderSizeDetail(data) {
  return request({
    url: "/pom/pomPurchaseApplyOrder/getApplyOrderSizeDetail",
    method: "post",
    data: data
  });
}

// 批量接单
export function batchReceiveOrder(data) {
  return request({
    url: "/mes/mesPurchaseOrder/batchReceiveOrder",
    method: "post",
    data: data
  });
}

// mes-拒单
export function refuseTakeOrder(data) {
  return request({
    url: "/pom/pomPurchaseApplyOrder/refuseTakeOrder",
    method: "post",
    data: data
  });
}

// 已接单列表
export function ordersReceivedList(data) {
  return request({
    url: "/mes/mesPurchaseOrder/purchaseOrderPage",
    method: "post",
    data: data
  });
}

// 已接单尺码数量
export function purchaseOrderSizeDetail(id) {
  return request({
    url: "/mes/mesPurchaseOrder/purchaseOrderSizeDetail/" + id,
    method: "post"
  });
}

// 获取接单异议详情
export function getReceiveOrderDetail(data) {
  return request({
    url: "/pom/pomPurchaseApplyOrder/getReceiveOrderDetail",
    method: "POST",
    data: data
  });
}

// 提交接单异议详情
export function submitReceiveOrderObjection(data) {
  return request({
    url: "/mes/mesPurchaseOrder/receiveOrderObjection",
    method: "POST",
    data: data
  });
}

// 接单异议详情保存
export function saveOrderObjDetails(data) {
  return request({
    url: "/mes/mesPurchaseOrder/receiveOrderObjectionSave",
    method: "POST",
    data: data
  });
}

// 已接单列表
export function getPurchaseOrderPage(data) {
  return request({
    url: "/mes/mesPurchaseOrder/purchaseOrderPage",
    method: "POST"
  });
}

// 生产资料数量统计
export function getListCount(data) {
  return request({
    url: "/mes/mesMeansProduction/listCount",
    method: "POST"
  });
}

// 生产核对资料-待核对资料列表
export function getProductionMeansCheckList(data) {
  return request({
    url: "/mes/mesMeansProduction/list",
    method: "POST",
    data: data
  });
}

// 获取生产核对资料详情
export function getOrderInforDetail(applyOrderCode) {
  return request({
    url: "/mes/mesMeansProduction/getMesMeansProductionDetail/" + applyOrderCode,
    method: "GET"
  });
}

// 保存生产资料审核
export function saveOrderInforDetail(data) {
  return request({
    url: "/mes/mesMeansProduction/saveMeansProduction",
    method: "POST",
    data: data
  });
}

// 提交生产资料审核
export function submitOrderInforDetail(data) {
  return request({
    url: "/mes/mesMeansProduction/submitMeansProduction",
    method: "POST",
    data: data
  });
}

// 获取生产资料下单尺码数量
export function getMeansProductionSize(id) {
  return request({
    url: "/mes/mesMeansProduction/getMeansProductionSize/" + id,
    method: "GET"
  });
}